var _defs, _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 28",
    width: 20,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "step10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 28,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAMAAABWBG9SAAAAAXNSR0IB2cksfwAAAHVQTFRFy8nPoJyotLG6tLG65OPm4+Ll4uHkPS1aQzBjQTNZQTNZQTNZPS1Z4+LlQzBjPi9Y4uHkPzBZy8nPoJuoPi5aQzBjQzBjbWV7oJuobmZ74+Ll////5eTnRDFkPi9YQTNZ/v7+PzBZQjRabmZ8oJyob2d8PS1af/QP8gAAACd0Uk5TIlA6AAgAAL//uQC4vgm7vAu8AFC9ALz////////////////////Ai/ORaAAAAIFJREFUeJytztkSgjAMheFQrMSFRVYVZRXe/xFhIDLpkLE3/pff9EwK4GwpVx20PmoNHm6dzperv2BgIIa+gBhGAs5vBZxVQLwZGKtkiWMK2RpHDNZyA6lfWNypB8NnSb3elnlVUxXD5jsv2bztqNb2JfF6/6EG2/zP6O1xBEh2wQQI+hqZyViQlQAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "step10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BODY"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabulka"
  }, /*#__PURE__*/React.createElement("use", {
    id: "dokument",
    href: "#img1",
    x: 0,
    y: 0
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.169e72ad6aa88f77588cd730c37ca07c.svg";
export { ForwardRef as ReactComponent };